import BaseNumberVTextField from './BaseNumberVTextField'
import { formatDateTimeStringTimeOnly } from '~/cynqueModules/utils/formatDateTimeStringTimeOnly'

// Vuetify 3 migration: inherits the <v-text-field> wrapper machinery from
// BaseNumberVTextField. parseNumeric:false — the value is formatted as-is.
// blurredFormat now uses the pure formatDateTimeStringTimeOnly (was
// window.$nuxt.$formatDateTimeStringTimeOnly, gone in Nuxt 4).
export default {
  extends: BaseNumberVTextField,
  props: {
    parseNumeric: {
      type: Boolean,
      default: false,
    },
    blurredFormat: {
      type: Function,
      default: (v) => {
        if (v) return formatDateTimeStringTimeOnly(v)
      },
    },
  },
}
